var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-0",attrs:{"id":"google_translate_element"}})
}
var staticRenderFns = []

export { render, staticRenderFns }